export default "__VITE_ASSET__D3HS6$VO__"